import Moment from 'moment-timezone';
import {
  GWO_DATE_STORAGE_KEYNAME,
  LSK_HIDE_ALL_RELEASE_ESSENTIAL,
  LSK_HIDE_NEWEST_RELEASE_ESSENTIAL,
} from '@/utils/constants';

// Get version from env
let version = process.env.VUE_APP_VERSION;
version = version && /^\d+\.\d+\.\d+$/.test(version)
  ? version
  : '';

// Get local storage info about hideReleaseEssential
const lsk = `${LSK_HIDE_NEWEST_RELEASE_ESSENTIAL}${version}`;
let hideReleaseEssential;
const hideAllReleaseEssential = window.localStorage.getItem(LSK_HIDE_ALL_RELEASE_ESSENTIAL) === 'true';
// If all versions are hidden, currentversion is automatically hidden
if (hideAllReleaseEssential) {
  hideReleaseEssential = true;
} else {
  hideReleaseEssential = window.localStorage.getItem(lsk) === 'true';
}

export default {
  attemptingLogin: false,
  // Json web token
  jwt: null,
  currentTeam: null,
  currentUser: null,
  // Whether a sumary of Shizen's usage of user data should be displayed
  displayDataUsage: false,
  // Keep state of expanded settings item
  expandedSettings: {},
  // Indicators as { <indicator_id>: {indicator_obj} }
  indicators: {},
  // Object as { <team_id>: { loading: false, data: [<array_of_indicators] } }
  indicatorsArrayPerTeam: {},
  // Object as { <team_id>: [<array_of_themes] }
  indicatorsThemesPerTeam: {},
  // Warning data per indicator
  indicatorWarnings: {},
  // Works like the above { <indicator_id>: {indicator_obj} }
  cumulatedIndicators: {},
  // Current message after the indicators analysis
  indicatorAnalysisMsg: '',
  // Cfg pages
  cfgPages: {},
  // Cfg pages widgets
  cfgPagesWidgets: {},
  // User data: { <user_id>: { loading: false, data: { id, firstName, lastName, } } }
  userData: {},
  // Informations arranged by dates : { <date>: { loading: false, info: [] }, <date>: ... }
  infoAtDate: {},
  // Informations accessible per ID
  infoPerId: {},
  // IDs of the announcement hidden by the user
  hiddenAnnouncements: [],

  // Navigation handling
  activeRouteClicked: null,
  activeRouteMatched: null,
  // Edition modals' zIndex. When a modal is displayed, the default zIndex is 1.
  // But when showing a problem reporting modal while on the problem sheet modal,
  // The zIndex must be increased.
  editionModalsZIndexes: {},

  // Release notes
  version,
  hideReleaseEssential,
  hideAllReleaseEssential,

  // GW related objects
  // Same behaviour but for GW indicators
  gwIndicators: {},
  // GW overlay variables
  gwOverlayVisibility: true,
  gwOverlayLastDate: Moment(localStorage.getItem(GWO_DATE_STORAGE_KEYNAME) || 0),
  // Gembawalks objects where the key is the id and the value is the object
  gwPerId: {},
};
